export default {
  //ECOMM_AUTHENTICATION
  GET_ECOMM_AUTHENTICATION_TOKEN:
    "ECOMM_AUTHENTICATION/GET_ECOMM_AUTHENTICATION_TOKEN",
  GET_ECOMM_AUTHENTICATION_TOKEN_SUCCESS:
    "ECOMM_AUTHENTICATION/GET_ECOMM_AUTHENTICATION_TOKEN_SUCCESS",
  GET_ECOMM_AUTHENTICATION_TOKEN_ERROR:
    "ECOMM_AUTHENTICATION/GET_ECOMM_AUTHENTICATION_TOKEN_ERROR",

  GET_ECOMM_USER_INFO: "ECOMM/GET_ECOMM_USER_INFO",
  GET_ECOMM_USER_INFO_SUCCESS: "ECOMM/GET_ECOMM_USER_INFO_SUCCESS",
  GET_ECOMM_USER_INFO_ERROR: "ECOMM/GET_ECOMM_USER_INFO_ERROR",
  GET_ECOMM_RETAILER_INFO: "ECOMM/GET_ECOMM_RETAILER_INFO",
  GET_ECOMM_RETAILER_INFO_SUCCESS: "ECOMM/GET_ECOMM_RETAILER_INFO_SUCCESS",
  GET_ECOMM_RETAILER_INFO_ERROR: "ECOMM/GET_ECOMM_RETAILER_INFO_ERROR",

  //ECOMM_CUSTOMER_LIST
  GET_CUSTOMER_LIST: "ECOMM_CUSTOMER/GET_CUSTOMER_LIST",
  GET_CUSTOMER_LIST_SUCCESS: "ECOMM_CUSTOMER/GET_CUSTOMER_LIST_SUCCESS",
  GET_CUSTOMER_LIST_ERROR: "ECOMM_CUSTOMER/GET_CUSTOMER_LIST_ERROR",

  GET_RETAILER_AUTHENTICATION_TOKEN:
    "RETAILER/GET_RETAILER_AUTHENTICATION_TOKEN",
  GET_RETAILER_AUTHENTICATION_TOKEN_SUCCESS:
    "RETAILER/GET_RETAILER_AUTHENTICATION_TOKEN_SUCCESS",
  GET_RETAILER_AUTHENTICATION_TOKEN_ERROR:
    "RETAILER/GET_RETAILER_AUTHENTICATION_TOKEN_ERROR",

  //SIDE_BAR
  UPDATE_TOGGLE_STATE: "SIDEBAR/UPDATE_TOGGLE_STATE",
  UPDATE_COLLAPSED_STATE: "SIDEBAR/UPDATE_COLLAPSED_STATE",

  //SERVICE_TYPES
  GET_SERVICE_TYPES_LIST: "SERVICE_TYPES/GET_SERVICE_TYPES_LIST",
  GET_SERVICE_TYPES_LIST_SUCCESS:
    "SERVICE_TYPES/GET_SERVICE_TYPES_LIST_SUCCESS",
  GET_SERVICE_TYPES_LIST_ERROR: "SERVICE_TYPES/GET_SERVICE_TYPES_LIST_ERROR",
  ADD_NEW_SERVICE_TYPE: "SERVICE_TYPES/ADD_NEW_SERVICE_TYPE",
  ADD_NEW_SERVICE_TYPE_SUCCESS: "SERVICE_TYPES/ADD_NEW_SERVICE_TYPE_SUCCESS",
  ADD_NEW_SERVICE_TYPE_ERROR: "SERVICE_TYPES/ADD_NEW_SERVICE_TYPE_ERROR",
  EDIT_SERVICE_TYPE: "SERVICE_TYPES/EDIT_SERVICE_TYPE",
  EDIT_SERVICE_TYPE_SUCCESS: "SERVICE_TYPES/EDIT_SERVICE_TYPE_SUCCESS",
  EDIT_SERVICE_TYPE_ERROR: "SERVICE_TYPES/EDIT_SERVICE_TYPE_ERROR",
  DELETE_SERVICE_TYPE: "SERVICE_TYPES/DELETE_SERVICE_TYPE",
  DELETE_SERVICE_TYPE_SUCCESS: "SERVICE_TYPES/DELETE_SERVICE_TYPE_SUCCESS",
  DELETE_SERVICE_TYPE_ERROR: "SERVICE_TYPES/DELETE_SERVICE_TYPE_ERROR",

  //SHAMPOO
  GET_SHAMPOO_LIST: "SHAMPOO/GET_SHAMPOO_LIST",
  GET_SHAMPOO_LIST_SUCCESS: "SHAMPOO/GET_SHAMPOO_LIST_SUCCESS",
  GET_SHAMPOO_LIST_ERROR: "SHAMPOO/GET_SHAMPOO_LIST_ERROR",
  ADD_SHAMPOO: "SHAMPOO/ADD_SHAMPOO",
  ADD_SHAMPOO_SUCCESS: "SHAMPOO/ADD_SHAMPOO_SUCCESS",
  ADD_SHAMPOO_ERROR: "SHAMPOO/ADD_SHAMPOO_ERROR",
  EDIT_SHAMPOO: "SHAMPOO/EDIT_SHAMPOO",
  EDIT_SHAMPOO_SUCCESS: "SHAMPOO/EDIT_SHAMPOO_SUCCESS",
  EDIT_SHAMPOO_ERROR: "SHAMPOO/EDIT_SHAMPOO_ERROR",
  BULK_UPDATE_SHAMPOO: "SHAMPOO/BULK_UPDATE_SHAMPOO",
  BULK_UPDATE_SHAMPOO_SUCCESS: "SHAMPOO/BULK_UPDATE_SHAMPOO_SUCCESS",
  BULK_UPDATE_SHAMPOO_ERROR: "SHAMPOO/BULK_UPDATE_SHAMPOO_ERROR",
  DELETE_SHAMPOO: "DELETE_SHAMPOO",
  DELETE_SHAMPOO_SUCCESS: "DELETE_SHAMPOO_SUCCESS",
  DELETE_SHAMPOO_ERROR: "DELETE_SHAMPOO_ERROR",

  //COLOGNE
  GET_COLOGNE_LIST: "COLOGNE/GET_COLOGNE_LIST",
  GET_COLOGNE_LIST_SUCCESS: "COLOGNE/GET_COLOGNE_LIST_SUCCESS",
  GET_COLOGNE_LIST_ERROR: "COLOGNE/GET_COLOGNE_LIST_ERROR",
  ADD_COLOGNE: "COLOGNE/ADD_COLOGNE",
  ADD_COLOGNE_SUCCESS: "COLOGNE/ADD_COLOGNE_SUCCESS",
  ADD_COLOGNE_ERROR: "COLOGNE/ADD_COLOGNE_ERROR",
  EDIT_COLOGNE: "COLOGNE/EDIT_COLOGNE",
  EDIT_COLOGNE_SUCCESS: "COLOGNE/EDIT_COLOGNE_SUCCESS",
  EDIT_COLOGNE_ERROR: "COLOGNE/EDIT_COLOGNE_ERROR",
  BULK_UPDATE_COLOGNE: "COLOGNE/BULK_UPDATE_COLOGNE",
  BULK_UPDATE_COLOGNE_SUCCESS: "COLOGNE/BULK_UPDATE_COLOGNE_SUCCESS",
  BULK_UPDATE_COLOGNE_ERROR: "COLOGNE/BULK_UPDATE_COLOGNE_ERROR",
  DELETE_COLOGNE: "DELETE_COLOGNE",
  DELETE_COLOGNE_SUCCESS: "DELETE_COLOGNE_SUCCESS",
  DELETE_COLOGNE_ERROR: "DELETE_COLOGNE_ERROR",
  GET_ACTIVE_COLOGNE_LIST: "COLOGNE/GET_ACTIVE_COLOGNE_LIST",
  GET_ACTIVE_COLOGNE_LIST_SUCCESS: "COLOGNE/GET_ACTIVE_COLOGNE_LIST_SUCCESS",
  GET_ACTIVE_COLOGNE_LIST_ERROR: "COLOGNE/GET_ACTIVE_COLOGNE_LIST_ERROR",

  //FEEDING_INFO
  GET_FEEDING_INFO: "FEEDING_INFO/GET_FEEDING_INFO",
  GET_FEEDING_INFO_SUCCESS: "FEEDING_INFO/GET_FEEDING_INFO_SUCCESS",
  GET_FEEDING_INFO_ERROR: "FEEDING_INFO/GET_FEEDING_INFO_ERROR",
  UPDATE_FEEDING_INFO: "FEEDING_INFO/UPDATE_FEEDING_INFO",
  UPDATE_FEEDING_INFO_SUCCESS: "FEEDING_INFO/UPDATE_FEEDING_INFO_SUCCESS",
  UPDATE_FEEDING_INFO_ERROR: "FEEDING_INFO/UPDATE_FEEDING_INFO_ERROR",

  //WAIVER_OF_LIABILITY_CONFIGURATION_INFO
  GET_WAIVER_OF_LIABILITY_CONFIGURATION_INFO: "WAIVER_OF_LIABILITY_CONFIGURATION_INFO/GET_WAIVER_OF_LIABILITY_CONFIGURATION_INFO",
  GET_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_SUCCESS: "WAIVER_OF_LIABILITY_CONFIGURATION_INFO/GET_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_SUCCESS",
  GET_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_ERROR: "WAIVER_OF_LIABILITY_CONFIGURATION_INFO/GET_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_ERROR",
  UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO: "WAIVER_OF_LIABILITY_CONFIGURATION_INFO/UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO",
  UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_SUCCESS: "WAIVER_OF_LIABILITY_CONFIGURATION_INFO/UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_SUCCESS",
  UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_ERROR: "WAIVER_OF_LIABILITY_CONFIGURATION_INFO/UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO_ERROR",

  //ATTENDANT
  GET_ATTENDANT_LIST: "GET_ATTENDANT_LIST",
  GET_ATTENDANT_LIST_SUCCESS: "GET_ATTENDANT_LIST_SUCCESS",
  GET_ATTENDANT_LIST_ERROR: "GET_ATTENDANT_LIST_ERROR",
  ADD_NEW_ATTENDANT: "ADD_NEW_ATTENDANT",
  ADD_NEW_ATTENDANT_SUCCESS: "ADD_NEW_ATTENDANT_SUCCESS",
  ADD_NEW_ATTENDANT_ERROR: "ADD_NEW_ATTENDANT_ERROR",
  GET_ATTENDANT_DETAILS: "GET_ATTENDANT_DETAILS",
  GET_ATTENDANT_DETAILS_SUCCESS: "GET_ATTENDANT_DETAILS_SUCCESS",
  GET_ATTENDANT_DETAILS_ERROR: "GET_ATTENDANT_DETAILS_ERROR",
  GET_ALL_ACTIVE_ATTENDANT_LIST: "ATTENDANT/GET_ALL_ACTIVE_ATTENDANT_LIST",
  GET_ALL_ACTIVE_ATTENDANT_LIST_SUCCESS:
    "ATTENDANT/GET_ALL_ACTIVE_ATTENDANT_LIST_SUCCESS",
  GET_ALL_ACTIVE_ATTENDANT_LIST_ERROR:
    "ATTENDANT/GET_ALL_ACTIVE_ATTENDANT_LIST_ERROR",
  UPDATE_ATTENDANT_DETAILS: "UPDATE_ATTENDANT_DETAILS",
  UPDATE_ATTENDANT_DETAILS_SUCCESS: "UPDATE_ATTENDANT_DETAILS_SUCCESS",
  UPDATE_ATTENDANT_DETAILS_ERROR: "UPDATE_ATTENDANT_DETAILS_ERROR",
  DELETE_ATTENDANT: "ATTENDANT/DELETE_ATTENDANT",
  DELETE_ATTENDANT_SUCCESS: "ATTENDANT/DELETE_ATTENDANT_SUCCESS",
  DELETE_ATTENDANT_ERROR: "ATTENDANT/DELETE_ATTENDANT_ERROR",

  // Config Docs
  GET_CONFIG_DOCS: "DOCUMENTS/GET_CONFIG_DOCS",
  GET_CONFIG_DOCS_SUCCESS: "DOCUMENTS/GET_CONFIG_DOCS_SUCCESS",
  GET_CONFIG_DOCS_ERROR: "DOCUMENTS/GET_CONFIG_DOCS_ERROR",
  ADD_NEW_CONFIG_DOC: "DOCUMENTS/ADD_NEW_CONFIG_DOC",
  ADD_NEW_CONFIG_DOC_SUCCESS: "DOCUMENTS/ADD_NEW_CONFIG_DOC_SUCCESS",
  ADD_NEW_CONFIG_DOC_ERROR: "DOCUMENTS/ADD_NEW_CONFIG_DOC_ERROR",
  EDIT_CONFIG_DOC: "DOCUMENTS/EDIT_CONFIG_DOC",
  EDIT_CONFIG_DOC_SUCCESS: "DOCUMENTS/EDIT_CONFIG_DOC_SUCCESS",
  EDIT_CONFIG_DOC_ERROR: "DOCUMENTS/EDIT_CONFIG_DOC_ERROR",
  DELETE_CONFIG_DOC: "DOCUMENTS/DELETE_CONFIG_DOC",
  DELETE_CONFIG_DOC_SUCCESS: "DOCUMENTS/DELETE_CONFIG_DOC_SUCCESS",
  DELETE_CONFIG_DOC_ERROR: "DOCUMENTS/DELETE_CONFIG_DOC_ERROR",
  GET_ACTIVE_CONFIG_DOCS: "DOCUMENTS/GET_ACTIVE_CONFIG_DOCS",
  GET_ACTIVE_CONFIG_DOCS_SUCCESS: "DOCUMENTS/GET_ACTIVE_CONFIG_DOCS_SUCCESS",
  GET_ACTIVE_CONFIG_DOCS_ERROR: "DOCUMENTS/GET_ACTIVE_CONFIG_DOCS_ERROR",

  //BOOK_APPOINTMENT
  GET_ACTIVE_SERVICE_TYPES_LIST: "SERVICE_TYPES/GET_ACTIVE_SERVICE_TYPES_LIST",
  GET_ACTIVE_SERVICE_TYPES_LIST_SUCCESS:
    "SERVICE_TYPES/GET_ACTIVE_SERVICE_TYPES_LIST_SUCCESS",
  GET_ACTIVE_SERVICE_TYPES_LIST_ERROR:
    "SERVICE_TYPES/GET_ACTIVE_SERVICE_TYPES_LIST_ERROR",
  GET_SERVICE_NAME_LIST: "SERVICE_TYPES/GET_SERVICE_NAME_LIST",
  GET_SERVICE_NAME_LIST_SUCCESS: "SERVICE_TYPES/GET_SERVICE_NAME_LIST_SUCCESS",
  GET_SERVICE_NAME_LIST_ERROR: "SERVICE_TYPES/GET_SERVICE_NAME_LIST_ERROR",
  GET_ACTIVE_SHAMPOO_LIST: "SERVICE_TYPES/GET_ACTIVE_SHAMPOO_LIST",
  GET_ACTIVE_SHAMPOO_LIST_SUCCESS:
    "SERVICE_TYPES/GET_ACTIVE_SHAMPOO_LIST_SUCCESS",
  GET_ACTIVE_SHAMPOO_LIST_ERROR: "SERVICE_TYPES/GET_ACTIVE_SHAMPOO_LIST_ERROR",
  CREATE_NEW_APPOINTMENT: "APPOINTMENTS/CREATE_NEW_APPOINTMENT",
  CREATE_NEW_APPOINTMENT_SUCCESS: "APPOINTMENTS/CREATE_NEW_APPOINTMENT_SUCCESS",
  CREATE_NEW_APPOINTMENT_ERROR: "APPOINTMENTS/CREATE_NEW_APPOINTMENT_ERROR",
  EDIT_APPOINTMENT_DETAILS: "APPOINTMENT/EDIT_APPOINTMENT_DETAILS",
  EDIT_APPOINTMENT_DETAILS_SUCCESS:
    "APPOINTMENT/EDIT_APPOINTMENT_DETAILS_SUCCESS",
  EDIT_APPOINTMENT_DETAILS_ERROR: "APPOINTMENT/EDIT_APPOINTMENT_DETAILS_ERROR",
  EDIT_SLOT_DETAILS: "SLOT/EDIT_SLOT_DETAILS",
  EDIT_SLOT_DETAILS_SUCCESS:
    "SLOT/EDIT_SLOT_DETAILS_SUCCESS",
  EDIT_SLOT_DETAILS_ERROR: "SLOT/EDIT_SLOT_DETAILS_ERROR",
  CANCEL_APPOINTMENT: "APPOINTMENT/CANCEL_APPOINTMENT",
  CANCEL_APPOINTMENT_SUCCESS: "APPOINTMENT/CANCEL_APPOINTMENT_SUCCESS",
  CANCEL_APPOINTMENT_ERROR: "APPOINTMENT/CANCEL_APPOINTMENT_ERROR",
  APPROVE_APPOINTMENT: "APPOINTMENT/APPROVE_APPOINTMENT",
  APPROVE_APPOINTMENT_SUCCESS: "APPOINTMENT/APPROVE_APPOINTMENT_SUCCESS",
  APPROVE_APPOINTMENT_ERROR: "APPOINTMENT/APPROVE_APPOINTMENT_ERROR",
  REJECT_APPOINTMENT: "APPOINTMENT/REJECT_APPOINTMENT",
  REJECT_APPOINTMENT_SUCCESS: "APPOINTMENT/REJECT_APPOINTMENT_SUCCESS",
  REJECT_APPOINTMENT_ERROR: "APPOINTMENT/REJECT_APPOINTMENT_ERROR",
  CANCEL_SLOT: "SLOTES/CANCEL_SLOT",
  CANCEL_SLOT_SUCCESS: "SLOTES/CANCEL_SLOT_SUCCESS",
  CANCEL_SLOT_ERROR: "SLOTES/CANCEL_SLOT_ERROR",
  GET_AVAILABLE_TIME_SLOTS: "APPOINTMENT/GET_AVAILABLE_TIME_SLOTS",
  GET_AVAILABLE_TIME_SLOTS_SUCCESS:
    "APPOINTMENT/GET_AVAILABLE_TIME_SLOTS_SUCCESS",
  GET_AVAILABLE_TIME_SLOTS_ERROR: "APPOINTMENT/GET_AVAILABLE_TIME_SLOTS_ERROR",
  //MANUAL SLOTS
  GET_AVAILABLE_TIME_SLOTS_MANUAL: "APPOINTMENT/GET_AVAILABLE_TIME_SLOTS_MANUAL",
  GET_AVAILABLE_TIME_SLOTS_MANUAL_SUCCESS:
    "APPOINTMENT/GET_AVAILABLE_TIME_SLOTS_MANUAL_SUCCESS",
  GET_AVAILABLE_TIME_SLOTS_MANUAL_ERROR: "APPOINTMENT/GET_AVAILABLE_TIME_SLOTS_MANUAL_ERROR",

  //WAIVE
    WAIVE:"APPOINTMENT/WAIVE",
    WAIVE_SUCCESS:"APPOINTMENT/WAIVE_SUCCESS",
    WAIVE_ERROR:"APPOITMENT/WAIVE_ERROR",
  //ADD_ON_SERVICES
  GET_ADD_ON_SERVICES_LIST: "ADD_ON_SERVICES/GET_ADD_ON_SERVICES_LIST",
  GET_ADD_ON_SERVICES_LIST_SUCCESS:
    "ADD_ON_SERVICES/GET_ADD_ON_SERVICES_LIST_SUCCESS",
  GET_ADD_ON_SERVICES_LIST_ERROR:
    "ADD_ON_SERVICES/GET_ADD_ON_SERVICES_LIST_ERROR",
  GET_ACTIVE_ADD_ON_SERVICE_LIST:
    "ADD_ON_SERVICES/GET_ACTIVE_ADD_ON_SERVICE_LIST",
  GET_ACTIVE_ADD_ON_SERVICE_LIST_SUCCESS:
    "ADD_ON_SERVICES/GET_ACTIVE_ADD_ON_SERVICE_LIST_SUCCESS",
  GET_ACTIVE_ADD_ON_SERVICE_LIST_ERROR:
    "ADD_ON_SERVICES/GET_ACTIVE_ADD_ON_SERVICE_LIST_ERROR",
  ADD_NEW_ADD_ON_SERVICE: "ADD_ON_SERVICES/ADD_NEW_ADD_ON_SERVICE",
  ADD_NEW_ADD_ON_SERVICE_SUCCESS:
    "ADD_ON_SERVICES/ADD_NEW_ADD_ON_SERVICE_SUCCESS",
  ADD_NEW_ADD_ON_SERVICE_ERROR: "ADD_ON_SERVICES/ADD_NEW_ADD_ON_SERVICE_ERROR",
  EDIT_ADD_ON_SERVICE: "ADD_ON_SERVICES/EDIT_ADD_ON_SERVICE",
  EDIT_ADD_ON_SERVICE_SUCCESS: "ADD_ON_SERVICES/EDIT_ADD_ON_SERVICE_SUCCESS",
  EDIT_ADD_ON_SERVICE_ERROR: "ADD_ON_SERVICES/EDIT_ADD_ON_SERVICE_ERROR",
  DELETE_ADD_ON_SERVICE: "ADD_ON_SERVICES/DELETE_ADD_ON_SERVICE",
  DELETE_ADD_ON_SERVICE_SUCCESS:
    "ADD_ON_SERVICES/DELETE_ADD_ON_SERVICE_SUCCESS",
  DELETE_ADD_ON_SERVICE_ERROR: "ADD_ON_SERVICES/DELETE_ADD_ON_SERVICE_ERROR",
  GET_ACTIVE_ADD_ON_SERVICES_LIST:
    "ADD_ON_SERVICES/GET_ACTIVE_ADD_ON_SERVICES_LIST",
  GET_ACTIVE_ADD_ON_SERVICES_LIST_SUCCESS:
    "ADD_ON_SERVICES/GET_ACTIVE_ADD_ON_SERVICES_LIST_SUCCESS",
  GET_ACTIVE_ADD_ON_SERVICES_LIST_ERROR:
    "ADD_ON_SERVICES/GET_ACTIVE_ADD_ON_SERVICES_LIST_ERROR",

  //PET_SIZES
  GET_PET_SIZES_LIST: "PET_SIZES/GET_PET_SIZES_LIST",
  GET_PET_SIZES_LIST_SUCCESS: "PET_SIZES/GET_PET_SIZES_LIST_SUCCESS",
  GET_PET_SIZES_LIST_ERROR: "PET_SIZES/GET_PET_SIZES_LIST_ERROR",
  EDIT_PET_SIZE: "PET_SIZES/EDIT_PET_SIZE",
  EDIT_PET_SIZE_SUCCESS: "PET_SIZES/EDIT_PET_SIZE_SUCCESS",
  EDIT_PET_SIZE_ERROR: "PET_SIZES/EDIT_PET_SIZE_ERROR",

  //EXTENDED_BEHAVIOR_INFORMATION
  GET_EXTENDED_BEHAVIOR_INFORMATION:
    "EXTENDED_BEHAVIOR/GET_EXTENDED_BEHAVIOR_INFORMATION",
  GET_EXTENDED_BEHAVIOR_INFORMATION_SUCCESS:
    "EXTENDED_BEHAVIOR/GET_EXTENDED_BEHAVIOR_INFORMATION_SUCCESS",
  GET_EXTENDED_BEHAVIOR_INFORMATION_ERROR:
    "EXTENDED_BEHAVIOR/GET_EXTENDED_BEHAVIOR_INFORMATION_ERROR",
  EDIT_EXTENDED_BEHAVIOR_INFORMATION:
    "EXTENDED_BEHAVIOR/EDIT_EXTENDED_BEHAVIOR_INFORMATION",
  EDIT_EXTENDED_BEHAVIOR_INFORMATION_SUCCESS:
    "EXTENDED_BEHAVIOR/EDIT_EXTENDED_BEHAVIOR_INFORMATION_SUCCESS",
  EDIT_EXTENDED_BEHAVIOR_INFORMATION_ERROR:
    "EXTENDED_BEHAVIOR/EDIT_EXTENDED_BEHAVIOR_INFORMATION_ERROR",

  //PET_TYPES
  SET_ACTIVE_PET: "PET_TYPES/SET_ACTIVE_PET",
  GET_ACTIVE_PET_TYPES_LIST: "PET_TYPES/GET_ACTIVE_PET_TYPES_LIST",
  GET_ACTIVE_PET_TYPES_LIST_SUCCESS:
    "PET_TYPES/GET_ACTIVE_PET_TYPES_LIST_SUCCESS",
  GET_ACTIVE_PET_TYPES_LIST_ERROR: "PET_TYPES/GET_ACTIVE_PET_TYPES_LIST_ERROR",
  GET_PET_TYPES_LIST: "PET_TYPES/GET_PET_TYPES_LIST",
  GET_PET_TYPES_LIST_SUCCESS: "PET_TYPES/GET_PET_TYPES_LIST_SUCCESS",
  GET_PET_TYPES_LIST_ERROR: "PET_TYPES/GET_PET_TYPES_LIST_ERROR",
  ADD_NEW_PET_TYPE: "PET_TYPES/ADD_NEW_PET_TYPE",
  ADD_NEW_PET_TYPE_SUCCESS: "PET_TYPES/ADD_NEW_PET_TYPE_SUCCESS",
  ADD_NEW_PET_TYPE_ERROR: "PET_TYPES/ADD_NEW_PET_TYPE_ERROR",
  DELETE_PET_TYPE: "PET_TYPES/DELETE_PET_TYPE",
  DELETE_PET_TYPE_SUCCESS: "PET_TYPES/DELETE_PET_TYPE_SUCCESS",
  DELETE_PET_TYPE_ERROR: "PET_TYPES/DELETE_PET_TYPE_ERROR",
  GET_PET_TYPES_INFO_BY_ID: "PET_TYPES/GET_PET_TYPES_INFO_BY_ID",
  GET_PET_TYPES_INFO_BY_ID_SUCCESS:
    "PET_TYPES/GET_PET_TYPES_INFO_BY_ID_SUCCESS",
  GET_PET_TYPES_INFO_BY_ID_ERROR: "PET_TYPES/GET_PET_TYPES_INFO_BY_ID_ERROR",
  GET_PET_DETAILS: "PET_TYPES/GET_PET_DETAILS",
  GET_PET_DETAILS_SUCCESS: "PET_TYPES/GET_PET_DETAILS_SUCCESS",
  GET_PET_DETAILS_ERROR: "PET_TYPES/GET_PET_DETAILS_ERROR",
  EDIT_PET_TYPE: "PET_TYPES/EDIT_PET_TYPE",
  EDIT_PET_TYPE_SUCCESS: "PET_TYPES/EDIT_PET_TYPE_SUCCESS",
  EDIT_PET_TYPE_ERROR: "PET_TYPES/EDIT_PET_TYPE_ERROR",
  GET_SELECTED_PET_TYPE_DETAILS: "PET_TYPES/GET_SELECTED_PET_TYPE_DETAILS",
  GET_SELECTED_PET_TYPE_DETAILS_SUCCESS:
    "PET_TYPES/GET_SELECTED_PET_TYPE_DETAILS_SUCCESS",
  GET_SELECTED_PET_TYPE_DETAILS_ERROR:
    "PET_TYPES/GET_SELECTED_PET_TYPE_DETAILS_ERROR",
  GET_ACTIVE_PET_TYPES_INFO_BY_ID: "PET_TYPES/GET_ACTIVE_PET_TYPES_INFO_BY_ID",
  GET_ACTIVE_PET_TYPES_INFO_BY_ID_SUCCESS:
    "PET_TYPES/GET_ACTIVE_PET_TYPES_INFO_BY_ID_SUCCESS",
  GET_ACTIVE_PET_TYPES_INFO_BY_ID_ERROR:
    "PET_TYPES/GET_ACTIVE_PET_TYPES_INFO_BY_ID_ERROR",
  SET_CURRENT_PET_DETAILS: "PET_TYPES/SET_CURRENT_PET_DETAILS",

  //VENUE
  GET_VENUE_LIST: "VENUE/GET_VENUE_LIST",
  GET_VENUE_LIST_SUCCESS: "VENUE/GET_VENUE_LIST_SUCCESS",
  GET_VENUE_LIST_ERROR: "VENUE/GET_VENUE_LIST_ERROR",

    //ALLVENUE
  GET_ALL_VENUE_LIST: "VENUE/GET_ALL_VENUE_LIST",
  GET_ALL_VENUE_LIST_SUCCESS: "VENUE/GET_ALL_VENUE_LIST_SUCCESS",
  GET_ALL_VENUE_LIST_ERROR: "VENUE/GET_ALL_VENUE_LIST_ERROR",

  DELETE_VENUE: "VENUE/DELETE_VENUE",
  DELETE_VENUE_SUCCESS: "VENUE/DELETE_VENUE_SUCCESS",
  DELETE_VENUE_ERROR: "VENUE/DELETE_VENUE_ERROR",
  ADD_VENUE: "VENUE/ADD_VENUE",
  ADD_VENUE_SUCCESS: "VENUE/ADD_VENUE_SUCCESS",
  ADD_VENUE_ERROR: "VENUE/ADD_VENUE_ERROR",
  GET_ACTIVE_PET_LIST: "GET_ACTIVE_PET_LIST",
  GET_ACTIVE_PET_LIST_SUCCESS: "GET_ACTIVE_PET_LIST_SUCCESS",
  GET_ACTIVE_PET_LIST_ERROR: "GET_ACTIVE_PET_LIST_ERROR",
  GET_GENERAL_PET_SIZE: "GET_GENERAL_PET_SIZE",
  GET_GENERAL_PET_SIZE_SUCCESS: "GET_GENERAL_PET_SIZE_SUCCESS",
  GET_GENERAL_PET_SIZE_ERROR: "GET_GENERAL_PET_SIZE_ERROR",
  GET_PET_NATURE: "GET_PET_NATURE",
  GET_PET_NATURE_SUCCESS: "GET_PET_NATURE_SUCCESS",
  GET_PET_NATURE_ERROR: "GET_PET_NATURE_ERROR",
  EDIT_VENUE: "VENUE/EDIT_VENUE",
  EDIT_VENUE_SUCCESS: "VENUE/EDIT_VENUE_SUCCESS",
  EDIT_VENUE_ERROR: "VENUE/EDIT_VENUE_ERROR",
  VENUE_BY_ID: "VENUE/VENUE_BY_ID",
  VENUE_BY_ID_SUCCESS: "VENUE/VENUE_BY_ID_SUCCESS",
  VENUE_BY_ID_ERROR: "VENUE/VENUE_BY_ID_ERROR",

  //SCHEDULE
  GET_SCHEDULE_LIST: "SCHEDULE/GET_SCHEDULE_LIST",
  GET_SCHEDULE_LIST_SUCCESS: "SCHEDULE/GET_SCHEDULE_LIST_SUCCESS",
  GET_SCHEDULE_LIST_ERROR: "SCHEDULE/GET_SCHEDULE_LIST_ERROR",
  GET_SCHEDULE_LIST_FOR_DAY: "SCHEDULE/GET_SCHEDULE_LIST_FOR_DAY",
  GET_SCHEDULE_LIST_FOR_DAY_SUCCESS: "SCHEDULE/GET_SCHEDULE_LIST_FOR_DAY_SUCCESS",
  GET_SCHEDULE_LIST_FOR_DAY_ERROR: "SCHEDULE/GET_SCHEDULE_LIST_FOR_DAY_ERROR",
  GET_SCHEDULE_LIST_WEEK: "SCHEDULE/GET_SCHEDULE_LIST_WEEK",
  GET_SCHEDULE_LIST_WEEK_SUCCESS: "SCHEDULE/GET_SCHEDULE_LIST_WEEK_SUCCESS",
  GET_SCHEDULE_LIST_WEEK_ERROR: "SCHEDULE/GET_SCHEDULE_LIST_WEEK_ERROR",
  GET_SLOTES_LIST: "SLOTES/GET_SLOTES_LIST",
  GET_SLOTES_LIST_SUCCESS: "SLOTES/GET_SLOTES_LIST_SUCCESS",
  GET_SLOTES_LIST_ERROR: "SLOTES/GET_SLOTES_LIST_ERROR",
  GET_SLOTES_LIST_WEEK: "SLOTES/GET_SLOTES_LIST_WEEK",
  GET_SLOTES_LIST_WEEK_SUCCESS: "SLOTES/GET_SLOTES_LIST_WEEK_SUCCESS",
  GET_SLOTES_LIST_WEEK_ERROR: "SLOTES/GET_SLOTES_LIST_WEEK_ERROR",

  GET_SCHEDULES_ON_DATE_LIST: "SCHEDULE/GET_SCHEDULES_ON_DATE_LIST",
  GET_SCHEDULES_ON_DATE_LIST_SUCCESS:
    "SCHEDULE/GET_SCHEDULES_ON_DATE_LIST_SUCCESS",
  GET_SCHEDULES_ON_DATE_LIST_ERROR: "SCHEDULE/GET_SCHEDULES_ON_DATE_LIST_ERROR",
  GET_SCHEDULES_ON_DATE_BY_PAGINATION_LIST:
    "SCHEDULE/GET_SCHEDULES_ON_DATE_BY_PAGINATION_LIST",
  GET_SCHEDULES_ON_DATE_BY_PAGINATION_LIST_SUCCESS:
    "SCHEDULE/GET_SCHEDULES_ON_DATE_BY_PAGINATION_LIST_SUCCESS",
  GET_SCHEDULES_ON_DATE_BY_PAGINATION_LIST_ERROR:
    "SCHEDULE/GET_SCHEDULES_ON_DATE_BY_PAGINATION_LIST_ERROR",

    // BKI-1232 :SLOTELISTONDATE
    GET_SLOTES_ON_DATE_LIST: "SCHEDULE/GET_SLOTES_ON_DATE_LIST",
    GET_SLOTES_ON_DATE_LIST_SUCCESS:
      "SCHEDULE/GET_SLOTES_ON_DATE_LIST_SUCCESS",
    GET_SLOTES_ON_DATE_LIST_ERROR: "SCHEDULE/GET_SLOTES_ON_DATE_LIST_ERROR",

//export via email
  SEND_EMAIL: "SCHEDULE/SEND_EMAIL",
  SEND_EMAIL_SUCCESS: "SCHEDULE/SEND_EMAIL_SUCCESS",
  SEND_EMAIL_ERROR: "SCHEDULE/SEND_EMAIL_ERROR",
  START_SERVICE: "SCHEDULE/START_SERVICE",
  START_SERVICE_SUCCESS: "SCHEDULE/START_SERVICE_SUCCESS",
  START_SERVICE_ERROR: "SCHEDULE/START_SERVICE_ERROR",
  STOP_SERVICE: "SCHEDULE/STOP_SERVICE",
  STOP_SERVICE_SUCCESS: "SCHEDULE/STOP_SERVICE_SUCCESS",
  STOP_SERVICE_ERROR: "SCHEDULE/STOP_SERVICE_ERROR",
  GET_APPOINTMENT_DETAILS_BY_ID: "SCHEDULE/GET_APPOINTMENT_DETAILS_BY_ID",
  GET_APPOINTMENT_DETAILS_BY_ID_SUCCESS:
    "SCHEDULE/GET_APPOINTMENT_DETAILS_BY_ID_SUCCESS",
  GET_APPOINTMENT_DETAILS_BY_ID_ERROR:
    "SCHEDULE/GET_APPOINTMENT_DETAILS_BY_ID_ERROR",
    GET_SLOT_DETAILS_BY_ID: "SCHEDULE/GET_SLOTES_DETAILS_BY_ID",
    GET_SLOT_DETAILS_BY_ID_SUCCESS:
      "SCHEDULE/GET_SLOTES_DETAILS_BY_ID_SUCCESS",
      GET_SLOT_DETAILS_BY_ID_ERROR:
      "SCHEDULE/GET_SLOTES_DETAILS_BY_ID_ERROR",

  //APPOINTMENTS
  APPOINTMENTS_LIST: "APPOINTMENTS/APPOINTMENTS_LIST",
  APPOINTMENTS_LIST_SUCCESS: "APPOINTMENTS/APPOINTMENTS_LIST_SUCCESS",
  APPOINTMENTS_LIST_ERROR: "APPOINTMENTS/APPOINTMENTS_LIST_ERROR",

    //FETCH APPOINTMENTS
    FETCH_APPOINTMENTS_LIST: "APPOINTMENTS/FETCH_APPOINTMENTS_LIST",
    FETCH_APPOINTMENTS_LIST_SUCCESS: "APPOINTMENTS/FETCH_APPOINTMENTS_LIST_SUCCESS",
    FETCH_APPOINTMENTS_LIST_ERROR: "APPOINTMENTS/FETCH_APPOINTMENTS_LIST_ERROR",

  //SERVICES
  GET_ALL_ACTIVE_VENUES_LIST: "SERVICES/GET_ALL_ACTIVE_VENUES_LIST",
  GET_ALL_ACTIVE_VENUES_LIST_SUCCESS:
    "SERVICES/GET_ALL_ACTIVE_VENUES_LIST_SUCCESS",
  GET_ALL_ACTIVE_VENUES_LIST_ERROR: "SERVICES/GET_ALL_ACTIVE_VENUES_LIST_ERROR",
  CREATE_NEW_SERVICE: "SERVICES/CREATE_NEW_SERVICE",
  CREATE_NEW_SERVICE_SUCCESS: "SERVICES/CREATE_NEW_SERVICE_SUCCESS",
  CREATE_NEW_SERVICE_ERROR: "SERVICES/CREATE_NEW_SERVICE_ERROR",
  GET_SERVICES_LIST: "SERVICES/GET_SERVICES_LIST",
  GET_SERVICES_LIST_SUCCESS: "SERVICES/GET_SERVICES_LIST_SUCCESS",
  GET_SERVICES_LIST_ERROR: "SERVICES/GET_SERVICES_LISTE_ERROR",
  EDIT_SERVICE: "SERVICES/EDIT_SERVICE",
  EDIT_SERVICE_SUCCESS: "SERVICES/EDIT_SERVICE_SUCCESS",
  EDIT_SERVICE_ERROR: "SERVICES/EDIT_SERVICE_ERROR",
  GET_SERVICE_DETAILS: "SERVICES/GET_SERVICE_DETAILS",
  GET_SERVICE_DETAILS_SUCCESS: "SERVICES/GET_SERVICE_DETAILS_SUCCESS",
  GET_SERVICE_DETAILS_ERROR: "SERVICES/GET_SERVICE_DETAILS_ERROR",
  DELETE_SERVICE: "SERVICES/DELETE_SERVICE",
  DELETE_SERVICE_SUCCESS: "SERVICES/DELETE_SERVICE_SUCCESS",
  DELETE_SERVICE_ERROR: "SERVICES/DELETE_SERVICE_ERROR",
  GET_ACTIVE_SERVICES_LIST: "SERVICES/GET_ACTIVE_SERVICES_LIST",
  GET_ACTIVE_SERVICES_LIST_SUCCESS: "SERVICES/GET_ACTIVE_SERVICES_LIST_SUCCESS",
  GET_ACTIVE_SERVICES_LIST_ERROR: "SERVICES/GET_ACTIVE_SERVICES_LIST_ERROR",
  GET_SERVICE_AMOUNT: "SERVICES/GET_SERVICE_AMOUNT",
  GET_SERVICE_AMOUNT_SUCCESS: "SERVICES/GET_SERVICE_AMOUNT_SUCCESS",
  GET_SERVICE_AMOUNT_ERROR: "SERVICES/GET_SERVICE_AMOUNT_ERROR",
  //GET SERVICE BY RETAILER
GET_SERVICE_DETAILS_BY_RETAILER:"SERVICES/GET_SERVICE_DETAILS_BY_RETAILER",
GET_SERVICE_DETAILS_BY_RETAILER_SUCCESS:"SERVICES/GET_SERVICE_DETAILS_BY_RETAILER_SUCCESS",
GET_SERVICE_DETAILS_BY_RETAILER_ERROR:"SERVICES/GET_SERVICE_DETAILS_BY_RETAILER_ERROR",



  //CUSTOMER_PETS_LIST
  GET_PETS_LIST: "CUSTOMER_PETS_LIST/GET_PETS_LIST",
  GET_PETS_LIST_SUCCESS: "CUSTOMER_PETS_LIST/GET_PETS_LIST_SUCCESS",
  GET_PETS_LIST_ERROR: "CUSTOMER_PETS_LIST/GET_PETS_LIST_ERROR",
  GET_ALL_PETS_LIST: "CUSTOMER_PETS_LIST/GET_ALL_PETS_LIST",
  GET_ALL_PETS_LIST_SUCCESS: "CUSTOMER_PETS_LIST/GET_ALL_PETS_LIST_SUCCESS",
  GET_ALL_PETS_LIST_ERROR: "CUSTOMER_PETS_LIST/GET_ALL_PETS_LIST_ERROR",
  GET_PET_INFO_BY_ID: "CUSTOMER_PETS_LIST/GET_PET_INFO_BY_ID",
  GET_PET_INFO_BY_ID_SUCCESS: "CUSTOMER_PETS_LIST/GET_PET_INFO_BY_ID_SUCCESS",
  GET_PET_INFO_BY_ID_ERROR: "CUSTOMER_PETS_LIST/GET_PET_INFO_BY_ID_ERROR",
  GET_PET_LIST_BY_CUSTOMER_ID: "CUSTOMER_PETS_LIST/GET_PET_LIST_BY_CUSTOMER_ID",
  GET_PET_LIST_BY_CUSTOMER_ID_SUCCESS:
    "CUSTOMER_PETS_LIST/GET_PET_LIST_BY_CUSTOMER_ID_SUCCESS",
  GET_PET_LIST_BY_CUSTOMER_ID_ERROR:
    "CUSTOMER_PETS_LIST/GET_PET_LIST_BY_CUSTOMER_ID_ERROR",

  GET_CUSTOMER_PET_LIST: "CUSTOMER_PETS_LIST/GET_CUSTOMER_PET_LIST",
  GET_CUSTOMER_PET_LIST_SUCCESS:
    "CUSTOMER_PETS_LIST/GET_CUSTOMER_PET_LIST_SUCCESS",
  GET_CUSTOMER_PET_LIST_ERROR: "CUSTOMER_PETS_LIST/GET_CUSTOMER_PET_LIST_ERROR",
  GET_CUSTOMER_DETAILS: "CUSTOMER/GET_CUSTOMER_DETAILS",
  GET_CUSTOMER_DETAILS_SUCCESS: "CUSTOMER/GET_CUSTOMER_DETAILS_SUCCESS",
  GET_CUSTOMER_DETAILS_ERROR: "CUSTOMER/GET_CUSTOMER_DETAILS_ERROR",
  DELETE_PET: "CUSTOMER/DELETE_PET",
  DELETE_PET_SUCCESS: "CUSTOMER/DELETE_PET_SUCCESS",
  DELETE_PET_ERROR: "CUSTOMER/DELETE_PET_ERROR",

  //GET ATTENDANT BY VENUE
  GET_ATTENDANT_BY_VENUE:"ATTENDANTLIST/GET_ATTEDANT_BY_VENUE",
  GET_ATTENDANT_BY_VENUE_SUCCESS:"ATTENDANTLIST/GET_ATTENDANT_BY_VENUE_SUCCESS",
  GET_ATTENDANT_BY_VENUE_ERROR:"ATTENDANTLIST/GET_ATTENDANT_BY_VENUE_ERROR",

  //CUSTOMER_PET_ADD
  ADD_NEW_PET: "CUSTOMER_PET_ADD/CUSTOMER_PET_ADD",
  ADD_NEW_PET_SUCCESS: "CUSTOMER_PET_ADD/CUSTOMER_PET_ADD_SUCCESS",
  ADD_NEW_PET_ERROR: "CUSTOMER_PET_ADD/CUSTOMER_PET_ADD_ERROR",
  CUSTOMER_PET_EDIT: "CUSTOMER_PET_ADD/CUSTOMER_PET_EDIT",
  CUSTOMER_PET_EDIT_SUCCESS: "CUSTOMER_PET_ADD/CUSTOMER_PET_EDIT_SUCCESS",
  CUSTOMER_PET_EDIT_ERROR: "CUSTOMER_PET_ADD/CUSTOMER_PET_EDIT_ERROR",

  //GET_SERVICE_HISTORY_DETAILS
  GET_SERVICE_HISTORY_DETAILS: "SERVICE_HISTORY/GET_SERVICE_HISTORY_DETAILS",
  GET_SERVICE_HISTORY_DETAILS_SUCCESS:
    "SERVICE_HISTORY/GET_SERVICE_HISTORY_DETAILS_SUCCESS",
  GET_SERVICE_HISTORY_DETAILS_ERROR:
    "SERVICE_HISTORY/GET_SERVICE_HISTORY_DETAILS_ERROR",

  // GET ALL Services
  GET_ALL_SERVICES: "SERVICE_HISTORY/GET_ALL_SERVICES",
  GET_ALL_SERVICES_SUCCESS:
    "SERVICE_HISTORY/GET_ALL_SERVICES_SUCCESS",
  GET_ALL_SERVICES_ERROR:
    "SERVICE_HISTORY/GET_ALL_SERVICES_ERROR",
  
  // GET_SERVICE_HISTORY_NOTES
  GET_SERVICE_HISTORY_NOTES: "SERVICE_HISTORY/GET_SERVICE_HISTORY_NOTES",
  GET_SERVICE_HISTORY_NOTES_SUCCESS:
    "SERVICE_HISTORY/GET_SERVICE_HISTORY_NOTES_SUCCESS",
  GET_SERVICE_HISTORY_NOTES_ERROR:
    "SERVICE_HISTORY/GET_SERVICE_HISTORY_NOTES_ERROR",

     // GET_SERVICE_HISTORY_NOTES_LIST
     GET_SERVICE_HISTORY_NOTES_LIST: "SERVICE_HISTORY/GET_SERVICE_HISTORY_NOTES_LIST",
     GET_SERVICE_HISTORY_NOTES_LIST_SUCCESS:
    "SERVICE_HISTORY/GET_SERVICE_HISTORY_NOTES_LIST_SUCCESS",
    GET_SERVICE_HISTORY_NOTES_LIST_ERROR:
    "SERVICE_HISTORY/GET_SERVICE_HISTORY_NOTES_LIST_ERROR",

  // GET_SERVICE_HISTORY_NOTES_BY_PET_ID_LIST
  GET_SERVICE_HISTORY_NOTES_BY_PET_ID_LIST: "SERVICE_HISTORY/GET_SERVICE_HISTORY_NOTES_BY_PET_ID_LIST",
  GET_SERVICE_HISTORY_NOTES_BY_PET_ID_LIST_SUCCESS:
      "SERVICE_HISTORY/GET_SERVICE_HISTORY_NOTES_BY_PET_ID_LIST_SUCCESS",
  GET_SERVICE_HISTORY_NOTES_BY_PET_ID_LIST_ERROR:
      "SERVICE_HISTORY/GET_SERVICE_HISTORY_NOTES_BY_PET_ID_LIST_ERROR",

     // ADD_SERVICE_HISTORY_NOTES_LIST
     ADD_SERVICE_HISTORY_NOTES_LIST: "SERVICE_HISTORY/ADD_SERVICE_HISTORY_NOTES_LIST",
     ADD_SERVICE_HISTORY_NOTES_LIST_SUCCESS:
    "SERVICE_HISTORY/ADD_SERVICE_HISTORY_NOTES_LIST_SUCCESS",
    ADD_SERVICE_HISTORY_NOTES_LIST_ERROR: 
    "SERVICE_HISTORY/ADD_SERVICE_HISTORY_NOTES_LIST_ERROR",

     // EDIT_SERVICE_HISTORY_NOTES_LIST
     EDIT_SERVICE_HISTORY_NOTES_LIST: "SERVICE_HISTORY/EDIT_SERVICE_HISTORY_NOTES_LIST",
     EDIT_SERVICE_HISTORY_NOTES_LIST_SUCCESS:
    "SERVICE_HISTORY/EDIT_SERVICE_HISTORY_NOTES_LIST_SUCCESS",
    EDIT_SERVICE_HISTORY_NOTES_LIST_ERROR:
    "SERVICE_HISTORY/EDIT_SERVICE_HISTORY_NOTES_LIST_ERROR",

  //SERVICE_HISTORY
  GET_SERVICE_HISTORY_LIST: "SERVICE_HISTORY/GET_SERVICE_HISTORY_LIST",
  GET_SERVICE_HISTORY_LIST_SUCCESS:
    "SERVICE_HISTORY/GET_SERVICE_HISTORY_LIST_SUCCESS",
  GET_SERVICE_HISTORY_LIST_ERROR:
    "SERVICE_HISTORY/GET_SERVICE_HISTORY_LIST_ERROR",
  //STORE_DETAILS
  GET_STORE_LIST: "GET_STORE_LIST",
  GET_STORE_LIST_SUCCESS: "GET_STORE_LIST_SUCCESS",
  GET_STORE_LIST_ERROR: "GET_STORE_LIST_ERROR",
  GET_STORE_BY_ID_LIST: "GET_STORE_BY_ID_LIST",
  GET_STORE_BY_ID_LIST_SUCCESS: "GET_STORE_BY_ID_LIST_SUCCESS",
  GET_STORE_BY_ID_LIST_ERROR: "GET_STORE_BY_ID_LIST_ERROR",
  // TIME ZONE LIST
  GET_TIME_ZONE_LIST: "GET_TIME_ZONE_LIST",
  GET_TIME_ZONE_LIST_SUCCESS: "GET_TIME_ZONE_LIST_SUCCESS",
  GET_TIME_ZONE_LIST_ERROR: "GET_TIME_ZONE_LIST_ERROR",
  SET_TIME_ZONE: "SET_TIME_ZONE",
  SET_TIME_ZONE_SUCCESS: "SET_TIME_ZONE_SUCCESS",
  SET_TIME_ZONE_ERROR: "SET_TIME_ZONE_ERROR",
  // STORE LIST BY SEARCHING NAME
  GET_STORE_LIST_BY_SEARCH: "GET_STORE_LIST_BY_SEARCH",
  GET_STORE_LIST_BY_SEARCH_SUCCESS: "GET_STORE_LIST_BY_SEARCH_SUCCESS",
  GET_STORE_LIST_BY_SEARCH_ERROR: "GET_STORE_LIST_BY_SEARCH_ERROR",
  // CUSTOMER LIST BY SEARCH
  GET_CUSTOMER_LIST_BY_SEARCH: "GET_CUSTOMER_LIST_BY_SEARCH",
  GET_CUSTOMER_LIST_BY_SEARCH_SUCCESS: "GET_CUSTOMER_LIST_BY_SEARCH_SUCCESS",
  GET_CUSTOMER_LIST_BY_SEARCH_ERROR: "GET_CUSTOMER_LIST_BY_SEARCH_ERROR",
   // CUSTOMER ADDRESS LIST
   GET_CUSTOMER_ADDRESS_LIST: "GET_CUSTOMER_ADDRESS_LIST",
   GET_CUSTOMER_ADDRESS_LIST_SUCCESS: "GET_CUSTOMER_ADDRESS_LIST_SUCCESS",
   GET_CUSTOMER_ADDRESS_LIST_ERROR: "GET_CUSTOMER_ADDRESS_LIST_ERROR",


   //SHAMPOOLIST BY PAGINATION

   GET_SHAMPOO_LIST_PAGINATED:"GET_SHAMPOO_LIST PAGINATED",
   GET_SHAMPOO_LIST_PAGINATED_SUCCESS:"GET_SHAMPOO_LIST_PAGINATED_SUCCESS",
   GET_SHAMPOO_LIST_PAGINATED_ERROR:"GET_SHAMPOO_LIST_PAGINATED_ERROR",


    //COLOGNELIST BY PAGINATION

    GET_COLOGNE_LIST_PAGINATED:"GET_COLOGNE_LIST PAGINATED",
    GET_COLOGNE_LIST_PAGINATED_SUCCESS:"GET_COLOGNE_LIST_PAGINATED_SUCCESS",
    GET_COLOGNE_LIST_PAGINATED_ERROR:"GET_COLOGNE_LIST_PAGINATED_ERROR",

     //ADDON_SERVICE BY PAGINATION

     GET_ADDON_SERVICE_LIST_PAGINATED:"GET_ADDON_SERVICE_LIST PAGINATED",
     GET_ADDON_SERVICE_LIST_PAGINATED_SUCCESS:"GET_ADDON_SERVICE_LIST_PAGINATED_SUCCESS",
     GET_ADDON_SERVICE_LIST_PAGINATED_ERROR:"GET_ADDON_SERVICE_LIST_PAGINATED_ERROR",

      //VENUE_LIST BY PAGINATION

      GET_VENUE_LIST_PAGINATED:"GET_ADDON_SERVICE_LIST PAGINATED",
      GET_VENUE_LIST_PAGINATED_SUCCESS:"GET_ADDON_SERVICE_LIST_PAGINATED_SUCCESS",
      GET_VENUE_LIST_PAGINATED_ERROR:"GET_ADDON_SERVICE_LIST_PAGINATED_ERROR",


      //SERVICE-TYPE PAGINATION

      PAGINATED_SERVICE_TYPE:"GET_SERVICE_TYPE_PAGINATED",
      PAGINATED_SERVICE_TYPE_SUCCESS:"GET_SERVICE_TYPE_PAGINATED_SUCCESS",
      PAGINATED_SERVICE_TYPE_ERROR:"GET_SERVICE_TYPE_PAGNATED_ERROR",
  //createslot
  CREATE_SLOT:"CREATE_SLOT",
  CREATE_SLOT_SUCCESS:"CREATE_SLOT_SUCCESS",
  CREATE_SLOT_ERROR:"CREATE_SLOT_ERROR,"



};
